import List from "./list/list.store";

export default {
  modules: { List },
};
